import React, {useState} from 'react';
import { inject } from "mobx-react";
import Prompt from '../../modals/prompt';
import RegistrationCard from '../../modals/registrationCard'
import "./Registration.css"


/* The checkout's "register here". The code screen that follows is NOT rendered here: Checkout shows this
   component only while the shared guest is signed in, and registrationCard signs out before handing over the
   new application - which unmounted this component, its own code screen with it, so the customer had a code
   in their mailbox and nowhere to type it, on a signed-out page. The application goes to the store's
   pendingSignup instead, and Home's code screen (always mounted) shows it. */
const Registration = ({title, feathersStore})=> {

  const [visiblePrompt, setVisiblePrompt] = useState(false);
  const [visibleRegister, setRegistrationModal] = useState(false);


  const openPrompt = ()=> {
    setVisiblePrompt(true);
  }

  const closePrompt = ()=> {
    setVisiblePrompt(false);
  }

  const openRegistrationModal = ()=> {
    setVisiblePrompt(false);
    setRegistrationModal(true);
  }

  const closeRegistrationModal = ()=> {
    setRegistrationModal(false);
  }

  //Runs after the sign-out, when this component may already be gone - the store outlives it.
  const openVerification = pload => {
    setRegistrationModal(false);
    feathersStore.setPendingSignup(pload);
  }

  return(
    <div >
      <Prompt
        visible={visiblePrompt}
        close={closePrompt}
        onClickRegister={openRegistrationModal}
        />
      <RegistrationCard
        visible={visibleRegister}
        close={closeRegistrationModal}
        onClickAway={closeRegistrationModal}
        onClick={openVerification}
      />
      <div onClick={openPrompt} className="here-word">{title}</div>
    </div>
  )
}

export default inject('feathersStore')(Registration);
